import { render } from "./HorseLaboratoryHistoryTab.vue?vue&type=template&id=ed3df5fc"
import script from "./HorseLaboratoryHistoryTab.vue?vue&type=script&lang=js"
export * from "./HorseLaboratoryHistoryTab.vue?vue&type=script&lang=js"

import "./HorseLaboratoryHistoryTab.vue?vue&type=style&index=0&id=ed3df5fc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__